import React from "react";
import Navbar from "../../../components/Navbar";
import Footer from "../../../components/Footer";
import { FaCheckCircle } from "react-icons/fa";
import { getOrderDetail } from "../../../api/user/restaurants";
import { useMutation, useQuery } from "@tanstack/react-query";
import { useNavigate, useSearchParams } from "react-router-dom";


const OrderConfirmation = () => {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams();
  const orderId = searchParams.get("order_id");

  const { data, isLoading } = useQuery({
    queryKey: ["order-confirmation", orderId],
    queryFn: () => getOrderDetail(orderId),
    enabled: !!orderId,
    keepPreviousData: true,
  });

  const order = data?.data?.order

  return (
    <>
      <div className="bg-[#FFF8EC] py-[45px]">
        <div className="container">
          <div>
            <FaCheckCircle size={32} color="#027D07" className="mx-auto" />
            <h2 className="lg:text-[30px] text-[20px] text-center font-semibold mb-[10px] lg:leading-[40px] text-black mt-[10px]">
              Order Confirmed!
            </h2>
            <p className="text-lg text-[#18181B] text-center">
              Your order has been placed successfully! You will receive a
              confirmation email shortly.
            </p>
          </div>
        </div>
      </div>
      <div className="lg:py-[60px] sm:py-[40px] py-[30px]">
        <div className="container">
          <div className="w-full mx-auto max-w-[1155px] md:py-[40px] md:px-[35px] p-[20px] border-[#DDDDDD] border rounded-[10px]">
            <h2 className="md:text-[25px] text-[20px] leading-[30px] md:leading-[40px] mb-[10px] font-semibold">
              Order Details
            </h2>
            <div className="flex gap-[5px] items-center mb-[10px] text-lg">
              <p className="font-medium text-[#18181B]">Order Number:</p>
              <p className="text-[#282828]">{order?._id}</p>
            </div>
            <div className="flex gap-[5px] items-center mb-[10px] text-lg">
              <p className="font-medium text-[#18181B]">Table number:</p>
              <p className="text-[#282828]">#{order?.reservationId?.tableNo} </p>
            </div>
            <div className="flex gap-[5px] items-center mb-[10px] text-lg">
              <p className="font-medium text-[#18181B]">Payment Method:</p>
              <p className="text-[#282828]">{order?.paymentDetails?.paymentGateway}</p>
            </div>
            <div className="text-right">
              <button onClick={()=> navigate("/trackorder" , {
                state : {orderId}
              })} className="w-full inline-block sm:max-w-[216px] ml-auto rounded-[2px] bg-[#4CAF50] text-[18px] text-white font-semibold p-[19px] green-shadow hover:bg-[#209b25] md:mt-[30px] mt-[20px] leading-[23px]">
                Track your Order
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OrderConfirmation;


// http://localhost:3000/orderconfirmation?session_id={CHECKOUT_SESSION_ID}&order_id=684fba8ee6a2f9259d4f553e&payment_transaction_id=DAED73B954604D5CB17858D35